import "./ViewErrorComponent.scss";

/**
 * @function ViewErrorComponent test components
 * @param info information that arrives procedurally provided
 * @returns {JSX.Element}
*/
const ViewErrorComponent = () => { 
    return ( <h1 className="CategoryDetailContainer__error">
            <div className="d-flex  justify-content-center">
                <div className="material-icons-outlined align-self-center font-size-40"> error </div>
                <div>Contenuto Non Disponibile</div>
            </div>
        </h1> );
};

ViewErrorComponent.defaultProps = {};

export default ViewErrorComponent;